export default __webpack_public_path__ + "assets/img/nodata.70cb29c29bfe9653b3fd6a3ac3fd3393.png";